// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"573ef85c","693":"573ef85c"}[chunkId] + ".chunk.css";
};